export const PRODUCT_TYPES = {
    SPRINT: "SPRINT",
    SOLO: "SOLO",
    ELEVATE: "ELEVATE",
    SPRINT_SKILL: "SPRINT_SKILL",
}

export const PRODUCT_ID_LIST = {
    SPRINT_BUSINESS_ENGLISH: 20,
    SPRINT_BUSINESS_GERMAN: 26,
    SPRINT_BUSINESS_FRENCH: 27,
    SPRINT_BUSINESS_SPANISH: 28,
    SOLO_BUSINESS_ENGLISH: 21,
    SOLO_BUSINESS_GERMAN: 22,
    SOLO_BUSINESS_FRENCH: 23,
    SOLO_BUSINESS_SPANISH: 24,
    SPRINT_BUSINESS_SKILLS: 18,
    ELEVATE_BUSINESS_ENGLISH: 25
}

export const PRODUCT_NAME_LIST = {
    SPRINT_BUSINESS_ENGLISH: 'oup_premium_blended',
    SPRINT_BUSINESS_GERMAN: 'sprint_business_german',
    SPRINT_BUSINESS_FRENCH: 'sprint_business_french',
    SPRINT_BUSINESS_SPANISH: 'sprint_business_spanish',
    SOLO_BUSINESS_ENGLISH: 'solo_english',
    SOLO_BUSINESS_GERMAN: 'solo_german',
    SOLO_BUSINESS_FRENCH: 'solo_french',
    SOLO_BUSINESS_SPANISH: 'solo_spanish',
    SPRINT_BUSINESS_SKILLS: '',
    ELEVATE_BUSINESS_ENGLISH: ''
}